import React from 'react';
import Btn, { BtnModifier } from '../../../components/molecules/Btn';
import { Icons } from '../../../components/atoms/SVG';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

type CollapsibleExpanderButtonBarProps = {
  collapseAllOnClick: () => void;
  collapseAllButtonDisabled: boolean;
  expandAllOnClick: () => void;
  expandAllButtonDisabled: boolean;
  ariaControls: string;
};

export function CollapsibleExpanderButtonBar({
  collapseAllOnClick,
  collapseAllButtonDisabled,
  expandAllOnClick,
  expandAllButtonDisabled,
  ariaControls,
}: CollapsibleExpanderButtonBarProps) {
  const { t } = useSonTranslation('phrases');

  return (
    <div className="collapsible-expander">
      <Btn
        modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
        svgSpriteId={Icons.CLOSE_ALL}
        titleText={t('collapseAllElements')}
        text={t('collapseAllElements')}
        hiddenText
        tooltipPlacement={TooltipPlacement.TOP}
        ariaDisabled={collapseAllButtonDisabled}
        ariaControls={ariaControls}
        onClick={collapseAllOnClick}
      />
      <Btn
        modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT, BtnModifier.MARGIN_LEFT]}
        svgSpriteId={Icons.OPEN_ALL}
        titleText={t('expandAllElements')}
        text={t('expandAllElements')}
        hiddenText
        tooltipPlacement={TooltipPlacement.TOP}
        ariaDisabled={expandAllButtonDisabled}
        ariaControls={ariaControls}
        onClick={expandAllOnClick}
      />
    </div>
  );
}
